import styled from 'styled-components';

import ChevronLeftRounded from '@mui/icons-material/ChevronLeftRounded';
import ChevronRightRounded from '@mui/icons-material/ChevronRightRounded';
import { BaseStyle } from '@nhl/nhl-breakaway-ui';

import { CarouselWrapper, Control, SkinnySlideBase } from '../baseCarousel/styles';

import { TransparentSlideCover } from './components/styles';

const LEFT_CURVED_BORDERS = `4px 0 0 4px`;
const RIGHT_CURVED_BORDERS = `0 4px 4px 0`;

export const SERIES_SKINNY_SLIDE_WIDTH = 56;
export const SERIES_SLIDE_WIDTH = 108;
export const SERIES_SLIDE_HEIGHT = 80;

export const SeriesPickerWrapper = styled.div`
    display: flex;
    flex-direction: row;
    position: relative;

    ${CarouselWrapper} {
        background-color: ${({ theme }) => theme.Surface.primary};
        color: ${({ theme }) => theme.Text.primary};
        border: 1px solid ${({ theme }) => theme.Surface.border};

        ${BaseStyle.Mixins.screenSizes.medium} {
            border-radius: 4px;
        }

        .alice-carousel__stage:last-child > ${TransparentSlideCover} {
            clip-path: inset(0 0 0 -32px round ${RIGHT_CURVED_BORDERS});
        }
    }
`;

export const SeriesRound = styled.div`
    ${BaseStyle.Mixins.fontStyles.ui['12m']}

    display: flex;
    align-items: center;
    justify-content: center;
    width: 45px;
    color: ${({ theme }) => theme.Text.primary};
`;

export const FilledChevronLeft = styled(ChevronLeftRounded)<{ $disabled?: boolean }>`
    border-radius: 50%;
    background-color: ${({ theme, $disabled }) => ($disabled ? theme.Surface.primary : theme.Text.primary)};

    path {
        color: ${({ theme }) => theme.Surface.primary};
    }
`;

export const FilledChevronRight = styled(ChevronRightRounded)<{ $disabled?: boolean }>`
    border-radius: 50%;
    background-color: ${({ theme, $disabled }) => ($disabled ? theme.Surface.primary : theme.Text.primary)};

    path {
        color: ${({ theme }) => theme.Surface.primary};
    }
`;

export const PrevNavControl = styled(Control)`
    ${({ theme }) => BaseStyle.Mixins.utility.boxShadow(60, theme.Surface.primary, [BaseStyle.StyleDirections.right])}
    clip-path: ${`inset(0 -120px 0 0 round ${LEFT_CURVED_BORDERS})`}; // this is the existing clip-path from the boxShadow mixin with the two left corners rounded, so the shadow doesn't poke out from under the rounded corners
    border-radius: ${LEFT_CURVED_BORDERS};
`;

export const NextNavControl = styled(Control)`
    ${({ theme }) => BaseStyle.Mixins.utility.boxShadow(16, theme.Surface.primary, [BaseStyle.StyleDirections.left])}
    clip-path: ${`inset(0 0 0 -32px round ${RIGHT_CURVED_BORDERS})`}; // as above but for the other end of the carousel
    border-radius: ${RIGHT_CURVED_BORDERS};
`;

export const SeriesSkinnySlide = styled(SkinnySlideBase)`
    top: 1px;
    width: ${SERIES_SKINNY_SLIDE_WIDTH}px;
    height: ${SERIES_SLIDE_HEIGHT - 1}px;
`;

export const SkinnySlideLeft = styled(SeriesSkinnySlide)`
    position: absolute;
    left: 0;

    ${BaseStyle.Mixins.screenSizes.medium} {
        border-radius: ${LEFT_CURVED_BORDERS};
    }
`;

export const SkinnySlideRight = styled(SeriesSkinnySlide)`
    position: absolute;
    right: 0;

    ${BaseStyle.Mixins.screenSizes.medium} {
        border-radius: ${RIGHT_CURVED_BORDERS};
    }
`;
